<template>
  <div>
    <v-dialog v-model="dialogregionwise" fullscreen persistent>
      <v-toolbar fixed color="white">
        <v-toolbar-title class="mb-2">
          <h3 class="titleText--text">
            {{ parmVariablename }}
          </h3></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items class="mb-2">
          <v-btn icon dark @click="dialogregionwise = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card flat color="rgb(243, 245, 248)">
        <v-card-title
          >
              <div style="width: 300px">
                <h5 class="grey--text ml-1">Select channel</h5>
                <v-select
                v-model="channelSelected"
                :items="channeldata"
                flat
                solo
                hide-details="auto"
                class="mb-5 mt-1 custom-shadow"
                style="border-radius: 8px"
                @change="callChannelChangeEvent()"
                >
      </v-select>
      </div>
            </v-card-title>
        <v-card-text class="mt-0">

          <div class="d-flex justify-space-between mt-0">
            <div v-for="(map, index) in mapData" :key="index" style="width: 350px">
              <v-card flat color="#F9FBFF">
                <v-card-title>
                  <h3 class="titleText--text">
                    {{ map.title }}
                  </h3>
                </v-card-title>
                <v-card-text>
                  <CtrlMap ref="ctrlmap" :settings="map.settings" />
                  <div>
                    <div class="d-flex justify-start mt-5">
                      <div
                        v-for="(item, index) in mapLegends(map.name)"
                        :key="index"
                        class="ml-3"
                      >
                        <h5 class="text-center">{{ new Intl.NumberFormat('en', {
                            notation: "compact",
                            compactDisplay: "short"
                          }).format(item) }}
                        </h5>
                        <div
                          style="width: 40px; height: 8px; border-radius: 3px"
                          :style="{
                            background: `rgb(${heatmapColors[map.name]}, ${
                              1 / (index + 1)
                            })`,
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>

          <v-simple-table class="mt-5">
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(header, index) in headers"
                    :key="index"
                    :class="index === 0 ? 'text-left' : 'text-center'"
                  >
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in getRegionData" :key="index">
                  <td class="titleText--text font-weight-bold">
                    {{ item.region }}
                  </td>
                  <td
                    class="titleText--text font-weight-bold text-center"
                    :style="{
                      background: getHeatmapColor('totalSales', index)
                        .background,
                    }"
                  >
                    {{ String(item.totalSales) | trgm_numberformateInK }}
                  </td>
                  <td
                    class="titleText--text font-weight-bold text-center"
                    :style="{
                      background: getHeatmapColor('spends', index).background,
                    }"
                  >
                    {{ String(item.spends) | trgm_numberformateInK }}
                  </td>
                  <td
                    class="titleText--text font-weight-bold text-center"
                    :style="{
                      background: getHeatmapColor('incrementalSales', index)
                        .background,
                    }"
                  >
                    {{ String(item.incrementalSales) | trgm_numberformateInK }}
                  </td>
                  <td
                    class="titleText--text font-weight-bold text-center"
                    :style="{
                      background: getHeatmapColor('roi', index).background,
                    }"
                  >
                    {{ String(item.roi) | trgm_numberformateInK }}
                  </td>
                  <td
                    class="titleText--text font-weight-bold text-center"
                    :style="{
                      background: getHeatmapColor('volumeResponse', index).background,
                    }"
                  >
                    {{ String(item.volumeResponse) | trgm_numberformateInK }}
                  </td>
                  <td class="titleText--text font-weight-bold text-center">
                    {{
                      String(item.activityPercentage) | trgm_numberformateInK
                    }}
                  </td>
                  <td class="titleText--text font-weight-bold text-center">
                    {{ String(item.salesVolume) | trgm_numberformateInK }}
                  </td>
                  <td class="titleText--text font-weight-bold text-center"
                  :style="{
                      background: getHeatmapColor('index', index).background,
                    }">
                    {{ String(item.index) | trgm_numberformateInK }}
                  </td>
                  <td class="titleText--text font-weight-bold text-center">
                    {{ String(item.activity) | trgm_numberformateInK }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CtrlMap from "./RegionwiseView/CtrlMapView.vue";
//import CtrlRegionWiseView from "./RegionwiseView/CtrlRegionWiseView.vue";

export default {
  data: () => ({
    itemlistfinal: [],
    itemlistcoefficients_table: [],
    itemlistmodel_statistics: [],
    itemlistactual_predicted_chart: [],
    itemlistvolume_area_chart: [],
    dialogregionwise: false,
    parmVariablename: "ROI & Volume Response",
    channeldata: [],
    channelSelected: [],
    regionData: [],
    headers: [
      "Region",
      "Total Sales",
      "Spends",
      "Incr. Sales",
      "ROI",
      "Volume Response",
      "Activity %",
      "Sales Volume %",
      "Index",
      "Activity",
    ],
    // for map
    mapIds: {
      'Wales': "GB-WLS",
      'Scotland': "GB-SCT",
      "North East England": "GB-UKC",
      "North West England": "GB-UKD",
      "North West": "GB-UKD",
      "Yorkshire and the Humber": "GB-UKE",
      "East Midlands": "GB-UKF",
      "West Midlands": "GB-UKG",
      "East of England": "GB-UKH",
      "Greater London": "GB-UKI",
      'London': "GB-UKI",
      "South East England": "GB-UKJ",
      "South West England": "GB-UKK",
      "South West": "GB-UKK",
      "Northern Ireland": "GB-NIR",
      'Guernsey': "GG",
      'Jersey': "JE",
      "Isle of Man": "IM",
      'Ireland': "IE",
    },

    mapData: [],
    mapDataRawchannel: [],
    mapDataRaw: [],
    mapDataRawRegion: [],
  }),
  components: {
    CtrlMap
  },
  methods: {
    numberFormat(num) {
      return new Intl.NumberFormat("en", {
        notation: "compact",
        compactDisplay: "short",
      }).format(num);
    },
    getHeatmapColor(value, index) {
      const maxValue = Math.max(
        ...this.getRegionData.map((item) => item[value])
      );
      const opacity = this.getRegionData.map(
        (item) => Math.round((item[value] / maxValue) * 100) / 100
      )[index];
      return {
        background: `rgb(${this.heatmapColors[value]}, ${opacity || 0})`,
        opacity: opacity,
      };
    },
    mapLegends(value) {
      const items = this.getRegionData.map((region) => region[value]).sort((a, b) => (a < b ? 1 : -1));
      let firstItem = items[0];
      let roundedItems = items.splice(1, items.length - 1).map((item) => Math.round((item / 2) * 100) / 100);
      return [firstItem, ...roundedItems].splice(0, 5);
    },
    callChannelChangeEvent() {
      this.CreateMapDataList();
      this.setRegionData();
    },
    OnloadCall(vardata, varregionlist) {
      this.dialogregionwise = true;
      this.itemlistfinal = vardata;
      this.dataregion = varregionlist;
      this.mapDataRawchannel = this.itemlistfinal.roi_total.filter(
        (a) => a.variable != "base" && a.region == "national"
      );
      this.mapDataRaw = this.itemlistfinal.roi_total.filter(
        (a) => a.region != "national" && a.variable != "base"
      );
      this.Fillchannels();

      this.CreateMapDataList();
      this.setRegionData();
    },
    CreateMapDataList() {
      this.mapData = []
      setTimeout(() => {
        this.mapData.push(
          {
            title: 'Total Sales',
            name: 'totalSales',
            settings: this.mapDataRaw.filter((a) => a.variable == this.channelSelected).map((item, index) => {
              return {
                id: this.mapIds[item.region],
                color: 0x51A7F8,
                opacity: this.getHeatmapColor('totalSales', index).opacity,
                value: item.total_sales_for_maps
              };
            })
          },
          {
            title: 'Spend',
            name: 'spends',
            settings: this.mapDataRaw.filter((a) => a.variable == this.channelSelected).map((item, index) => {
              return {
                id: this.mapIds[item.region],
                color: 0x2CD8C5,
                opacity: this.getHeatmapColor('spends', index).opacity,
                value: item.spend
              };
            })
          },
          {
            title: 'Incremental Sales',
            name: 'incrementalSales',
            settings: this.mapDataRaw.filter((a) => a.variable == this.channelSelected).map((item, index) => {
              return {
                id: this.mapIds[item.region],
                color: 0x826AF9,
                opacity: this.getHeatmapColor('incrementalSales', index).opacity,
                value: item.volume
              };
            })
          },
          {
            title: 'ROI',
            name: 'roi',
            settings: this.mapDataRaw.filter((a) => a.variable == this.channelSelected).map((item, index) => {
              return {
                id: this.mapIds[item.region],
                color: 0xC67FE8,
                opacity: this.getHeatmapColor('roi', index).opacity,
                value: item.roi
              };
            })
          },
          {
            title: 'Volume Response',
            name: 'volumeResponse',
            settings: this.mapDataRaw.filter((a) => a.variable == this.channelSelected).map((item, index) => {
              return {
                id: this.mapIds[item.region],
                color: 0xd6731c,
                opacity: this.getHeatmapColor('volumeResponse', index).opacity,
                value: item.volume_response
              };
            })
          },
        )
      }, 1000)
    },
    Fillchannels() {
      let templist = [];
      for (let el in this.mapDataRawchannel) {
        templist.push(this.mapDataRawchannel[el].variable);
      }
      this.channeldata = templist;
      this.channelSelected = templist[0];
      //return [...new Set(this.mapDataRawFull({ key: 'variable', region: 'national' }).keys)]
    },
    setRegionData() {
      //alert("setRegionData");
      this.regionData = [];
      this.mapDataRaw
        .filter((item) => item.variable === this.getSelectedChannel)
        .forEach((item) => {
          this.regionData.push({
            region: item.region,
            totalSales: item.total_sales_for_maps
              ? item.total_sales_for_maps
              : 0,
            spends: item.spend ? item.spend : 0,
            incrementalSales: item.volume ? item.volume : 0,
            roi: item.roi ? item.roi : 0,
            volumeResponse: item.volume_response ? item.volume_response : 0,
            activityPercentage: item.activity_percentage
              ? item.activity_percentage
              : 0,
            salesVolume: item.volume_contribution
              ? item.volume_contribution
              : 0,
            index: item.activity_index ? item.activity_index : 0,
            activity: item.execution ? item.execution : 0
          });
        });
    },
  },
  mounted() {
    this.$refs.Reloadmap;
  },
  computed: {
    getSelectedChannel() {
      return this.channelSelected;
    },
    getRegionData() {
      return this.regionData;
    },
    heatmapColors() {
      return {
        totalSales: "81, 167, 248",
        spends: "44, 216, 196",
        incrementalSales: "130, 106, 249",
        volume_response: "219, 88, 18",
        volumeResponse: "219, 88, 18",
        value: "130, 106, 249",
        Value: "130, 106, 249",
        roi: "198, 127, 232",
        ROI: "198, 127, 232",
        index: '0, 168, 101'
      };
    },
    channels() {
      let templist = [];
      for (let el in this.mapDataRawchannel) {
        templist.push(this.mapDataRawchannel[el].variable);
      }
      return templist;
      //return [...new Set(this.mapDataRawFull({ key: 'variable', region: 'national' }).keys)]
    },
  },
};
</script>

<style scoped>
.headerbox {
  font-weight: bold;
  font-style: italic;
  font-size: 25px;
  color: black;
}

.headerboxtitle {
  font-size: 20px;
}

.card2 {
  background-color: #ffff00;
}
.customselectbox {
  padding-top: 10px !important;
  width: 60% !important;
  right: 0%;
}
.custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
  border-color: white !important;

}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-color: white !important;
  background-color: #F9FBFF !important;
  color: #505D6F !important;
  font-weight: 700 !important;
}
</style>
